import OrganizationTab from './OrganizationTab'
export default OrganizationTab


// WEBPACK FOOTER //
// ./src/components/ChannelTabs/BookingTab/MappingTabs/OrganizationTab/index.js